var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-submit"},[_c('Button',{attrs:{"theme":"primary order-submit-button","disabled":_vm.disabled,"loading":_vm.orderSubmitting},on:{"click":_vm.submitOrder}},[_vm._v("\n    "+_vm._s(_vm.submitBtnText)+"\n    "),(_vm.isVirtual)?_c('BtnCornerTag',{attrs:{"tag-name":_vm.$t('settings.virtual-tag')}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }